module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-09.a0b808bb.png";